<!-- <div class="d-flex justify-content-between mb-4">
  <div class="wccard p-4 text-black border-e0e0e0 w25" >
    <p class="f-32 font-weight-600 mb-4">{{activeDays}}</p>
    <p class="f-16">Avg daily active users <i class="far fa-info-circle text-9696"></i></p>
  </div>
  <div class="wccard p-4 text-black border-e0e0e0 w25">
    <p class="f-32 font-weight-600 mb-4">{{averageSearchPerformed}}</p>
    <p class="f-16">Avg search performed <i class="far fa-info-circle text-9696"></i></p>
  </div>
  <div class="wccard p-4 text-black border-e0e0e0 w25">
    <p class="f-32 font-weight-600 mb-4">{{averageProfileViewed}}</p>
    <p class="f-16">Avg profiles viewed <i class="far fa-info-circle text-9696"></i></p>
  </div>
  <div class="wccard p-4 text-black border-e0e0e0 w25">
    <p class="f-32 font-weight-600 mb-4">{{averageContactsRevealed}}</p>
    <p class="f-16">Avg contacts revealed<i class="far fa-info-circle text-9696"></i></p>
  </div>
</div> -->
<div class="row mb-4">
  <div class="col-md-3 pr-1">
    <div class="wccard p-4 text-black border-e0e0e0" >
      <p class="f-32 font-weight-600 mb-4">{{activeDays}}</p>
      <p class="f-16">Avg Daily Active Users <i class="far fa-info-circle text-9696" matTooltip="Average daily active user over the selected date range" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
    </div>
  </div>
  <div class="col-md-3 pr-1">
    <div class="wccard p-4 text-black border-e0e0e0">
      <p class="f-32 font-weight-600 mb-4">{{averageSearchPerformed}}</p>
      <p class="f-16">Avg Search Performed <i class="far fa-info-circle text-9696" matTooltip="Average search performed on active days over the selected date range" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
    </div>
  </div>
  <div class="col-md-3 pr-1">
    <div class="wccard p-4 text-black border-e0e0e0">
      <p class="f-32 font-weight-600 mb-4">{{averageProfileViewed}}</p>
      <p class="f-16">Avg Profiles Viewed <i class="far fa-info-circle text-9696" matTooltip="Average profile viewed on active days over the selected date range" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
    </div>
  </div>
  <div class="col-md-3">
    <div class="wccard p-4 text-black border-e0e0e0">
      <p class="f-32 font-weight-600 mb-4">{{averageContactsRevealed}}</p>
      <p class="f-16">Avg Contacts Revealed <i class="far fa-info-circle text-9696" matTooltip="Average contact revealed on active days over the selected date range" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
    </div>
  </div>
</div>
<div class="row mb-4 d-flex">
  <div class="col-md-6 pr-1">
    <div class="wccard text-black">
      <div class="d-flex justify-content-between align-items-center f-14 font-weight-600 mb-3">
        <div class="d-flex align-items-center">
          <span class="mr-2">
            <span class="card-lable"><i class="fa-solid fa-chart-simple"></i></span>
          </span>
          <p>Activity <i class="far fa-info-circle text-9696" matTooltip="This will provide an usage overview for the selected time period" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
        <div>
          <select data-testid="auto-app-team-members-reports-select-1" name="" id="" class="wc-form-control border-e0e0e0" (change)="getActivityDetails($event)" [(ngModel)]="activitySelected">
            <option value="searches-performed" default>Searches Performed</option>
            <option value="active-days">Active Days</option>
            <option value="profile-viewed">Profile Viewed</option>
            <option value="contacts-revealed">Contacts Revealed</option>
          </select>
        </div>
      
      </div>
        <div>
          <p class="f-12 text-a2a2a2 mb-4">Total number of {{reportType}} over the selected date range</p>
        </div>
        <div style="overflow-x: auto;">
                    
<fusioncharts
[width]="width"
[height]="height"
type="timeseries"
[dataSource]="chartData"
*ngIf="chartData && chartData?.data">

</fusioncharts>

        </div>
    </div>
  </div>
  <div class="col-md-6">  
    <div class="wccard text-black">
      <div class="d-flex justify-content-between align-items-center f-14 font-weight-600 mb-3">
        <div class="d-flex align-items-center">
          <span class="mr-2">
            <span class="card-lable"><i class="fa-solid fa-coins"></i></span>
          </span>
          <p>Credit Usage <i class="far fa-info-circle text-9696" matTooltip="This will provide an usage overview for the selected time period" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
          <!-- <p class="current-credit f-12">Team's Current Credit: {{currentCredit}}</p> -->
        </div>
        <!-- <div>
          <span class="alert-label">Total Credits: 100 (50 used & 50 unused)</span>
        </div> -->
        <div class="d-flex" *ngIf="batches && batches.length">
          <!-- <span><span class="font-weight-600">1 - {{users.length > 2 ? 2 : users.length}}</span> of {{users.length}} results</span> -->
          <span class="font-weight-600">{{getStartIndex()}} - {{batches && batches.length == 0 ? 0 :  getEndIndex()}} of {{batches && batches.length == 0 ? 0 : totalUsersLength}} results </span>
          <span class="ml-2">
            <i class="fas fa-caret-left mr-1" (click)="pagination('prev')" [ngClass]="{'text-9696 pointer-none': isAtFirstPage()}"></i>
            <i class="fas fa-caret-right" (click)="pagination('next')" [ngClass]="{'text-9696 pointer-none': isLastPage()}"></i>
          </span>

          
        </div>
      </div>
      <div class="row align-items-center">
      
        <div class="col" style="overflow-x: auto;">
<!--           
          <fusioncharts
          width="600"
          height="400"
          type="stackedcolumn2d"
          dataFormat="json"
          [dataSource]="creditData">
        </fusioncharts>  

         -->

         <!-- {{creditData?.dataset | json}} ddddddddddddd -->
        <fusioncharts
        width="100%"
        height="400"
        type="stackedcolumn2d"
        dataFormat="json"
        [dataSource]="creditData"
        *ngIf="creditData && creditData?.dataset?.length; else noCreditSection;">
      </fusioncharts>  

      <p style="text-align: center;">Name</p>

      <p style="position: absolute; top: 50%; left:-28px; transform: rotate(270deg);">No. of credits</p>

      
      <ng-template #noCreditSection>
        <div style="text-align: center; margin-top:100px;">
          <img src="../../../assets/emptystate.png" alt="No data found" style="width: 100px; height: 125px;">
          <p style="color: #484b59;" class="f-14 font-weight-600" >No data Found</p>
        </div>
      </ng-template>

      

      
        </div>
      </div>
  

    </div>
  </div>  
</div>  
<div class="row mb-3px">
  <div class="col">
    <div class="wccard text-black">
      <div class="d-flex justify-content-between align-items-end f-14 font-weight-600">
        <div class="" style="width: 300px;">
          <div class="d-flex mb-2 align-items-center">
            <span class="mr-2">
              <span class="card-lable"><i class="fa-solid fa-users"></i></span>
            </span>
            <p>Team members <i class="far fa-info-circle text-9696" matTooltip="Average search performed over the selected date range" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
          
            </div>
            <div>
              <input data-testid="auto-app-team-members-reports-input-1" type="text" class="wc-form-control border-e0e0e0 w-100" placeholder="Search Team members" (input)="filterUsers($event.target.value)" (blur)="filterUsers('')" placeholder="Search by name" [matAutocomplete]="team_users" trigger="matAutocompleteTrigger" >
              <mat-autocomplete #team_users="matAutocomplete"
              (optionSelected)="selectOption($event.option.value)">
              <mat-option *ngFor="let data of activityDataList" [value]="data.name">{{data?.name}} <span>
                  </span></mat-option>
            </mat-autocomplete>
            </div>
        </div>
        <div>
          <button data-testid="auto-app-team-members-reports-button-1" class="btn-trms-medium" (click)="downloadReport()">Download reports</button>
        </div>
      
      </div>
      
    </div>
  </div>
</div>
<div class="wccard mb-3px">
  <div class="row" style="margin-left: 4px;">
    <div class="d-flex align-items-center">
      <label class="wc-checkbox d-flex report-check">
        <input data-testid="auto-app-team-members-reports-input-2" type="checkbox" id="mycheck" name="mycheck" [(ngModel)]="selected" (change)="selectAll(selected)" class="mr-2">
        <i class="fas fa-check"></i>
      </label>
     
    </div>
    <div class="col text-9696" *ngFor="let header of activityTableHeader">
      <div class="d-flex justify-content-between align-items-center f-12">
        <span  style="white-space: pre-line">{{header}}</span>
        <span class="d-flex flex-column align-items-center justify-content-center">
          <i class="far fa-info-circle mb-1" *ngIf="header != 'Team \n Members'" [matTooltip]="getTooltipText(header)" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i>
          <span class="d-flex flex-column align-items-center justify-content-center pointer" (click)="sortAndFilterData(header)">
            <i class="fas fa-caret-up" style="margin-bottom: -7px;"></i>
            <i class="fas fa-caret-down"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="wccard mb-3px" *ngFor="let data of activityDataList">
  <div class="row" style="margin-left: 4px;">
    <div class="d-flex align-items-center">
      <label class="wc-checkbox d-flex report-check">
        <input data-testid="auto-app-team-members-reports-input-3" type="checkbox" id="mycheck" name="mycheck" [(ngModel)]="data.selected" (change)="selectActivity(data, data.selected)" [checked]="data.selected" (change)="checkboxChanged()"  [disabled]="isLastCheckboxSelected(data)"
          class="mr-2">
        <i class="fas fa-check"></i>
      </label>

      <div *ngIf="noCheckboxSelected">Please select at least one checkbox.</div>
      <input data-testid="auto-app-team-members-reports-input-4" type="hidden" [(ngModel)]="initialCheckboxState">

    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span style="display: grid;">
          <span class="text-truncate" matTooltip="{{data.name}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{data.name}}</span>
          </span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.acitvedays}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.searchperformed}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.talentpoolcreated}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.profilesviewed}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.contactrevealed}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.creditsused}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.profilesaddedtotalentpool}}</span>
      </div>
    </div>
    <div class="col">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{data.mailssent}}</span>
      </div>
    </div>

  </div>
</div>
<br>
